const cleanIdentifier = (value) => String(value ?? "").trim();

export const getProofEmailPoNumber = (poData = {}) =>
  cleanIdentifier(poData?.poNumber ?? poData?.purchaseOrderNumber ?? "");

export const getProofEmailSalesOrderNumber = (poData = {}) => {
  const candidates = [
    poData?.salesOrder?.estimationId,
    poData?.estimationId,
    poData?.salesOrder?.salesOrderNumber,
    poData?.salesOrder?.SalesOrderNumber,
    poData?.salesOrder?.soNumber,
    poData?.salesOrder?.SONumber,
    poData?.salesOrderNumber,
    poData?.soNumber,
    poData?.salesOrderId,
  ];

  return cleanIdentifier(candidates.find((candidate) => cleanIdentifier(candidate)));
};

export const buildDefaultProofSubject = (poData = {}) => {
  const poNumber = getProofEmailPoNumber(poData);
  const salesOrderNumber = getProofEmailSalesOrderNumber(poData);
  const parts = [];

  if (poNumber) parts.push(`PO #${poNumber}`);
  if (salesOrderNumber) parts.push(`SO #${salesOrderNumber}`);

  return parts.length ? `Art Proof Ready – ${parts.join(" | ")}` : "Art Proof Ready";
};

export const stripRevisedPrefix = (subject = "") =>
  String(subject || "").replace(/^REVISED:\s*/i, "").trimStart();

export const applyRevisedPrefix = (subject = "") => {
  const clean = stripRevisedPrefix(subject);
  return clean ? `REVISED: ${clean}` : "REVISED:";
};

export const resolveProofEmailSender = ({ fromOptions = [], fromUserId = "" } = {}) => {
  const selected = fromOptions.find((option) => String(option?.id) === String(fromUserId));
  const email = cleanIdentifier(selected?.email).toLowerCase();
  if (!selected || !email) return null;

  return {
    name: cleanIdentifier(selected.name) || email,
    email,
    userId: selected.id != null ? String(selected.id) : "",
  };
};

export const mergeProofSenderIntoBcc = (bcc = [], sender = null) => {
  const senderEmail = cleanIdentifier(sender?.email).toLowerCase();
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(senderEmail)) return Array.isArray(bcc) ? bcc : [];

  const existing = Array.isArray(bcc) ? bcc : [];
  const alreadyIncluded = existing.some((contact) => {
    const email = typeof contact === "string" ? contact : contact?.email ?? contact?.id;
    return cleanIdentifier(email).toLowerCase() === senderEmail;
  });
  if (alreadyIncluded) return existing;

  return [
    ...existing,
    {
      id: senderEmail,
      email: senderEmail,
      name: cleanIdentifier(sender?.name) || senderEmail,
    },
  ];
};
